import React, { useState } from 'react'
import domestic from './../images/domestic.png'
import vocational from './../images/vocational.png'
import professional from './../images/professional.png'

function Services() {
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')

    const modalActivate = (e) => {
        e.preventDefault()
        const img = e.currentTarget
        const newTitle = img.getAttribute("data-title")
        const newDesc = img.getAttribute("data-desc")
        setTitle(newTitle)
        setDescription(newDesc)
        document.getElementById("openPromoModal").click()
    }

    return (
        <section id="services">
            <div className="container">
                <div className="row mb-4">
                    <div className="col-md-6 h-100 text-center text-md-start p-0 p-md-5 pb-3">
                        <h2 className="mt-3">Our Services</h2>
                        <p className="mb-0" style={{fontSize: 14}}>At Hustle Connects, we offer a range of services designed to help you get things done efficiently and effectively</p>
                    </div>
                    <div className="col-md-6" >
                        <img src={domestic} alt="Domestic" className='rounded' data-title="domestic" onClick={modalActivate} style={{width: "100%"}} data-desc="From cleaning and laundry to cooking, weeding, and errands — find help for the chores that keep life running. If you’re great at keeping homes in order, this is your space to shine, earn, and grow your hustle." />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6" style={{ marginBottom: 30}}>
                        <img src={vocational} alt="vocational" className='rounded' data-title="vocational" onClick={modalActivate} style={{width: "100%"}} data-desc="Whether you need a carpenter to fix a door, a hairstylist for a fresh look, or a plumber for urgent repairs — Hustle Connects links you directly to skilled individuals near you. If you’ve mastered a craft, your next customer could be just a tap away." />
                    </div>
                    <div className="col-md-6">
                        <img src={professional} alt="professional" className='rounded' data-title="professional" onClick={modalActivate} style={{width: "100%"}} data-desc="From web development to digital marketing, graphic design to accounting — connect with professionals ready to bring their skills to your project. If your work lives on a laptop or in a boardroom, this is where you find the clients who need it." />
                    </div>
                </div>
            </div>
            <button id="openPromoModal" type="button" className="d-none" data-bs-toggle="modal" data-bs-target="#promoModal"></button>
            <div className="modal fade" id="promoModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-4 text-center">
                        <h5 className="fw-bold" style={{textTransform: 'uppercase'}}>{title}</h5>
                        <p className="mt-3 fs-1" style={{}}>{description}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services
